import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import room from './modules/room'
import mailRoom from './modules/mailRoom'

Vue.use(Vuex)
export default new Vuex.Store({
  strict: true,
  modules: {
    auth,
    room,
    mailRoom
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js